import actions from '@/core/store/adesao/documentos-adesao/actions'

export default {
	actions,
}
